import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../api/axiosInstance";

export default function Currency() {
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const saveTimerRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get(`getCurrency`, { signal: controller.signal });
        const data = res.data;
        const row = Array.isArray(data?.data) && data.data.length > 0 ? data.data[0] : (data || {});
        setCurrency(String(row.currency || ""));
        const t = row.updated_at || row.created_at || "";
        setLastUpdated(t ? new Date(t).toLocaleString("en-GB") : "");
      } catch (err) {
        if (err.name !== 'CanceledError') {
          setCurrency("");
          setLastUpdated("");
        }
      } finally {
        setLoading(false);
      }
    };
    load();
    return () => controller.abort();
  }, []);

  const persist = async (value) => {
    const endpoint = `updateCurrency/1`;
    try {
      try {
        await axiosInstance.put(endpoint, { currency: String(value) });
      } catch (err) {
        const params = new URLSearchParams();
        params.append("currency", String(value));
        await axiosInstance.put(endpoint, params, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
      }
      setLastUpdated(new Date().toLocaleString("en-GB"));
    } catch (_) { }
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="tableHeader d-flex justify-content-between align-items-center p-3">
                <h5 className="mb-0">Currency</h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Currency</th>
                        <th>Updated</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td style={{ maxWidth: 220 }}>
                          <input
                            type="text"
                            className="form-control"
                            value={currency}
                            disabled={loading}
                            onChange={(e) => {
                              const val = e.target.value;
                              setCurrency(val);
                              if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                              saveTimerRef.current = setTimeout(() => persist(val), 400);
                            }}
                            placeholder="e.g., Rs, BHD"
                          />
                        </td>
                        <td>{lastUpdated || '-'}</td>
                        <td className="text-center">
                          <button
                            className="bgBtn"
                            disabled={loading}
                            onClick={() => persist(currency)}
                          >
                            {loading ? "Saving..." : "Save"}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}











